// src/audio/sounds.js
import audioManager from "./AudioManager";

// Добавляем звуки в менеджер
audioManager.addSound("spinSound", "/sounds/spin.ogg", { loop: true });
audioManager.addSound("s_buttonClick", "/sounds/buttonClick.mp3");
audioManager.addSound("s_gameBg", "/sounds/gameBg2.mp3", { loop: true });
audioManager.addSound("s_charging", "/sounds/charging.mp3");
audioManager.addSound("s_gameSwitch", "/sounds/gameSwitch.mp3");
audioManager.addSound("s_newAura", "/sounds/newAura.ogg");
audioManager.addSound("s_newAura2", "/sounds/newAura2.ogg");
audioManager.addSound("s_takeAura", "/sounds/takeAura.ogg");
audioManager.addSound("s_auraMenu", "/sounds/auraMenu.mp3");
audioManager.addSound("s_useItem", "/sounds/useItem.mp3");
audioManager.addSound("s_mainAura", "/sounds/mainAuraUpdate.ogg");
audioManager.addSound("s_spin", "/sounds/spin.mp3");
audioManager.addSound("s_spin2", "/sounds/spin2.mp3");
audioManager.addSound("s_spinError", "/sounds/spinError.mp3");
audioManager.addSound("s_tapGamePoint", "/sounds/tapGamePoint.ogg");
audioManager.addSound("s_tapGameLoose", "/sounds/tapGameLoose.ogg");
audioManager.addSound("s_tapGameCoins", "/sounds/tapGameCoins.ogg");
audioManager.addSound("s_auraBg", "/sounds/auraBg.ogg", {
  loop: true,
  volume: 0.3,
});
audioManager.addSound("s_shopBg", "/sounds/shopBg.ogg", { loop: true });
audioManager.addSound("s_shopBg2", "/sounds/shopBg2.ogg", { loop: true });
audioManager.addSound("s_shopBg3", "/sounds/shopBg3.ogg", { loop: true });
audioManager.addSound("s_nope", "/sounds/nope.ogg");
audioManager.addSound("s_click01", "/sounds/click01.wav");
audioManager.addSound("s_coins", "/sounds/coins.ogg");
audioManager.addSound("s_joeBg", "/sounds/joeBg.ogg", {
  loop: true,
  volume: 0.2,
});
audioManager.addSound("s_joeLoose", "/sounds/joeLoose.ogg");
audioManager.addSound("s_joeWin", "/sounds/joeWin.ogg");
audioManager.addSound("s_joeWin2", "/sounds/joeWin2.ogg");
audioManager.addSound("s_slotEnd", "/sounds/slotEnd.ogg");
audioManager.addSound("s_slotsStart", "/sounds/slotsStart.mp3");
audioManager.addSound("s_slotsButton", "/sounds/slotsButton.mp3");
audioManager.addSound("s_joeSpinning", "/sounds/joeSpinning.ogg");
audioManager.addSound("s_joeError", "/sounds/joeError.mp3");
audioManager.addSound("s_forging", "/sounds/forging.ogg");
audioManager.addSound("s_sewing", "/sounds/sewing.ogg");
audioManager.addSound("s_craftPotion", "/sounds/craftPotion.mp3");
audioManager.addSound("s_usePotion", "/sounds/usePotion.mp3");
audioManager.addSound("s_blacksmith", "/sounds/blacksmith.ogg", { loop: true });
audioManager.addSound("s_tailor", "/sounds/tailor.ogg", { loop: true });
audioManager.addSound("s_city", "/sounds/city.ogg", { loop: true });
audioManager.addSound("s_skeleton", "/sounds/skeleton.ogg", {
  loop: true,
  volume: 0.65,
});

audioManager.addSound("s_adventures", "/sounds/dungeonsListBg.ogg", {
  loop: true,
});
audioManager.addSound("s_dungeon01", "/sounds/dungeonFightBg01.ogg", {
  loop: true,
});
audioManager.addSound("s_hit01", "/sounds/hit01.ogg");
audioManager.addSound("s_hit02", "/sounds/hit02.ogg");
audioManager.addSound("s_critHit01", "/sounds/hitCrit.ogg");
audioManager.addSound("s_angels", "/sounds/angels.ogg");

export default audioManager;
